<template>
  <div class="main course-page">
    <div class="main_r" ref="pageBody">
      <el-tabs
        v-model="activeName"
        style="width: 100%; height: 100%;"
        :before-leave="beforeTabLeave"
      >
        <el-tab-pane label="课程列表" name="first">
          <div class="page-top" :class="{ 'is-collapsed': filterCollapsed }">
            <div class="page-top__header">
              <div class="title_line">课程列表</div>
              <el-link
                :underline="false"
                type="primary"
                class="collapse-toggle"
                @click="filterCollapsed = !filterCollapsed"
              >
                <i :class="filterCollapsed ? 'el-icon-arrow-down' : 'el-icon-arrow-up'"></i>
                {{ filterCollapsed ? '展开' : '收起' }}
              </el-link>
            </div>

            <div class="page-top__body">
              <div class="stats-bar">
              <div class="stat-card stat-total">
                <span class="stat-value">{{ courseStats.total }}</span>
                <span class="stat-label">课程总数</span>
              </div>
              <div class="stat-card stat-home">
                <span class="stat-value">
                  <i class="status-dot is-home"></i>{{ courseStats.homeRecommend }}
                </span>
                <span class="stat-label">首页推荐</span>
              </div>
              <div class="stat-card stat-banner">
                <span class="stat-value">
                  <i class="status-dot is-banner"></i>{{ courseStats.bannerRecommend }}
                </span>
                <span class="stat-label">Banner 推荐</span>
              </div>
              <div class="stat-card stat-avg">
                <span class="stat-value">{{ courseStats.avgTime }}</span>
                <span class="stat-label">平均时长(秒)</span>
              </div>
            </div>

            <div class="filter-strip">
              <div class="filter-strip__fields">
                <div class="filter-field filter-field--compact">
                  <label class="filter-field__label">课程分类</label>
                  <el-select v-model="queryData.courseType" placeholder="课程分类" size="small">
                    <el-option label="课程分类" value="0"></el-option>
                    <el-option
                      v-for="item in aptustwoGvListCourseType"
                      :key="item.gv"
                      :label="item.name"
                      :value="item.gv"
                    ></el-option>
                  </el-select>
                </div>
                <div class="filter-field filter-field--compact">
                  <label class="filter-field__label">优先分类</label>
                  <el-select v-model="queryData.priorityType" placeholder="优先分类" size="small">
                    <el-option label="新课优先" value="1"></el-option>
                    <el-option label="人气优先" value="2"></el-option>
                  </el-select>
                </div>
                <div class="filter-field filter-field--compact">
                  <label class="filter-field__label">课程难度</label>
                  <el-select v-model="queryData.courseDifficulty" placeholder="课程难度" size="small">
                    <el-option label="课程难度" value="0"></el-option>
                    <el-option
                      v-for="item in aptustwoGvListCourseDifficulty"
                      :key="item.gv"
                      :label="item.name"
                      :value="item.gv"
                    ></el-option>
                  </el-select>
                </div>
                <div class="filter-field filter-field--compact">
                  <label class="filter-field__label">课程时长分类</label>
                  <el-select v-model="queryData.courseTimeType" placeholder="课程时长分类" size="small">
                    <el-option label="课程时长分类" value="0"></el-option>
                    <el-option
                      v-for="item in aptustwoGvListCourseTimeType"
                      :key="item.gv"
                      :label="item.name"
                      :value="item.gv"
                    ></el-option>
                  </el-select>
                </div>
                <div class="filter-field filter-field--compact">
                  <label class="filter-field__label">部位分类</label>
                  <el-select v-model="queryData.bodyType" placeholder="部位分类" size="small">
                    <el-option label="部位分类" value=""></el-option>
                    <el-option
                      v-for="item in aptustwoGvListBodyType"
                      :key="item.gv"
                      :label="item.name"
                      :value="item.gv"
                    ></el-option>
                  </el-select>
                </div>
                <div class="filter-field filter-field--compact">
                  <label class="filter-field__label">所需配件</label>
                  <el-select v-model="queryData.courseAccessories" placeholder="所需配件" size="small">
                    <el-option label="所需配件" value=""></el-option>
                    <el-option
                      v-for="item in aptustwoGvListAccessories"
                      :key="item.gv"
                      :label="item.name"
                      :value="item.gv"
                    ></el-option>
                  </el-select>
                </div>
                <div class="filter-field filter-field--compact">
                  <label class="filter-field__label">课程名称</label>
                  <el-input v-model="queryData.courseName" placeholder="输入名称" clearable size="small"></el-input>
                </div>
                <div class="filter-field filter-field--compact">
                  <label class="filter-field__label">首页推荐</label>
                  <el-select v-model="queryData.isHome" placeholder="全部" size="small">
                    <el-option label="全部" value="-1"></el-option>
                    <el-option label="否" value="0"></el-option>
                    <el-option label="是" value="1"></el-option>
                  </el-select>
                </div>
                <div class="filter-field filter-field--compact">
                  <label class="filter-field__label">Banner 推荐</label>
                  <el-select v-model="queryData.isBanner" placeholder="全部" size="small">
                    <el-option label="全部" value="-1"></el-option>
                    <el-option label="否" value="0"></el-option>
                    <el-option label="是" value="1"></el-option>
                  </el-select>
                </div>
              </div>
              <div class="filter-strip__actions">
                <el-button type="primary" size="small" icon="el-icon-search" @click="clickQuery">查询</el-button>
                <el-button type="primary" size="small" plain icon="el-icon-refresh-left" @click="clickQueryReset">重置</el-button>
                <span class="filter-strip__sep"></span>
                <el-button type="primary" size="small" icon="el-icon-plus" @click="clickdialogAdd">新增</el-button>
                <el-button type="success" size="small" @click="clickBatchAdd">批量新增</el-button>
              </div>
            </div>
          </div>
          </div>

          <!-- 列表 -->
          <div class="table-section" ref="tableSection">
            <div class="table-container" ref="tableContainer">
              <el-table
                ref="courseTable"
                :data="dataList"
                class="course-table"
                :height="tableHeight"
                :header-cell-style="tableHeaderStyle"
                :cell-style="tableCellStyle"
                @sort-change="handleSortChange"
              >
                <el-table-column
                  prop="id"
                  label="序号"
                  width="80"
                  fixed="left"
                  sortable="custom"
                  align="center"
                ></el-table-column>
                <el-table-column
                  prop="courseTypeUi"
                  label="课程分类"
                  width="190"
                  sortable="custom"
                  show-overflow-tooltip
                  align="center"
                ></el-table-column>
                <el-table-column
                  prop="bodyTypeUi"
                  label="部位分类"
                  width="160"
                  sortable="custom"
                  show-overflow-tooltip
                ></el-table-column>
                <el-table-column
                  prop="courseName"
                  label="课程名称"
                  width="220"
                  sortable="custom"
                  show-overflow-tooltip
                ></el-table-column>
                <el-table-column prop="" label="列表封面" width="108" align="center">
                  <template v-slot="scope">
                    <el-image
                      v-if="scope.row.courseIconUi"
                      style="width: 48px; height: 48px"
                      :src="scope.row.courseIconUi"
                      :preview-src-list="[scope.row.courseIconUi]"
                      fit="cover">
                    </el-image>
                    <span v-else>-</span>
                  </template>
                </el-table-column>
                <el-table-column prop="" label="详情页封面" width="160" align="center">
                  <template v-slot="scope">
                    <el-image
                      v-if="scope.row.courseIconDetailsUi"
                      style="width: 48px; height: 48px"
                      :src="scope.row.courseIconDetailsUi"
                      :preview-src-list="[scope.row.courseIconDetailsUi]"
                      fit="cover">
                    </el-image>
                    <span v-else>-</span>
                  </template>
                </el-table-column>
                <el-table-column prop="" label="Banner封面" width="160" align="center">
                  <template v-slot="scope">
                    <el-image
                      v-if="scope.row.courseIconBannerUi"
                      style="width: 48px; height: 48px"
                      :src="scope.row.courseIconBannerUi"
                      :preview-src-list="[scope.row.courseIconBannerUi]"
                      fit="cover">
                    </el-image>
                    <span v-else>-</span>
                  </template>
                </el-table-column>
                <el-table-column
                  prop="courseDifficultyUi"
                  label="课程难度"
                  width="112"
                  sortable="custom"
                  align="center"
                ></el-table-column>
                <el-table-column
                  prop="courseTime"
                  label="课程时长"
                  width="112"
                  sortable="custom"
                  align="center"
                >
                  <template slot-scope="props">
                    {{ props.row.courseTime }}秒
                  </template>
                </el-table-column>
                <el-table-column
                  prop="courseRest"
                  label="组之间的休息"
                  width="148"
                  sortable="custom"
                  align="center"
                >
                  <template slot-scope="props">
                    {{ props.row.courseRest }}秒
                  </template>
                </el-table-column>
                <el-table-column
                  prop="courseRestMax"
                  label="动作之间的休息"
                  width="168"
                  sortable="custom"
                  align="center"
                >
                  <template slot-scope="props">
                    {{ props.row.courseRestMax }}秒
                  </template>
                </el-table-column>
                <el-table-column prop="" label="预计容量" width="112" align="center">
                  <template v-slot="scope"> {{ scope.row.courseKg }}Kg </template>
                </el-table-column>
                <el-table-column
                  prop="courseKcal"
                  label="预计消耗"
                  width="112"
                  sortable="custom"
                  align="center"
                >
                  <template v-slot="scope">
                    {{ scope.row.courseKcal }}Kcal
                  </template>
                </el-table-column>
                <el-table-column prop="isHome" label="首页推荐" width="112" sortable="custom" align="center">
                  <template slot-scope="props">
                    <el-tag :type="props.row.isHome == 1 ? 'success' : 'info'" size="small" effect="plain">
                      {{ props.row.isHome == 1 ? '是' : '否' }}
                    </el-tag>
                  </template>
                </el-table-column>
                <el-table-column
                  prop="isBanner"
                  label="Banner推荐"
                  width="148"
                  sortable="custom"
                  align="center"
                >
                  <template slot-scope="props">
                    <el-tag :type="props.row.isBanner == 1 ? 'warning' : 'info'" size="small" effect="plain">
                      {{ props.row.isBanner == 1 ? '是' : '否' }}
                    </el-tag>
                  </template>
                </el-table-column>
                <el-table-column
                  prop="createTime"
                  label="创建时间"
                  min-width="220"
                  width="220"
                  sortable="custom"
                  align="left"
                  header-align="left"
                  class-name="col-datetime"
                ></el-table-column>
                <el-table-column label="英文名称" min-width="140" show-overflow-tooltip>
                  <template slot-scope="scope">
                    <span>{{ (translationMap[scope.row.id] && translationMap[scope.row.id]['en'] && translationMap[scope.row.id]['en']['course_name']) || '-' }}</span>
                  </template>
                </el-table-column>
                <el-table-column label="德文名称" min-width="140" show-overflow-tooltip>
                  <template slot-scope="scope">
                    <span>{{ (translationMap[scope.row.id] && translationMap[scope.row.id]['de'] && translationMap[scope.row.id]['de']['course_name']) || '-' }}</span>
                  </template>
                </el-table-column>
                <el-table-column label="操作" width="188" fixed="right" align="center" class-name="col-operations">
                  <template slot-scope="scope">
                    <div class="action-group">
                      <el-tooltip effect="dark" content="编辑" placement="top" :enterable="false">
                        <el-button type="text" class="action-btn" icon="el-icon-edit" @click="clickdialogEdit(scope.row)"></el-button>
                      </el-tooltip>
                      <el-tooltip effect="dark" content="删除" placement="top" :enterable="false">
                        <el-button type="text" class="action-btn action-btn--danger" icon="el-icon-delete" @click="ClickDelete(scope.row)"></el-button>
                      </el-tooltip>
                      <el-tooltip effect="dark" content="翻译" placement="top" :enterable="false">
                        <el-button type="text" class="action-btn" icon="el-icon-s-opportunity" @click="clickI18n(scope.row)"></el-button>
                      </el-tooltip>
                      <el-tooltip effect="dark" content="管理课程动作" placement="top" :enterable="false">
                        <el-button type="text" class="action-btn" icon="el-icon-view" @click="gotoWebTwoCourseAction(scope.row)"></el-button>
                      </el-tooltip>
                    </div>
                  </template>
                </el-table-column>
              </el-table>
            </div>
          </div>

          <!-- 分页 -->
          <div class="pagination-wrapper">
            <el-pagination
              @size-change="handleSizeChange"
              @current-change="handleCurrentChange"
              :current-page="page_no"
              :page-sizes="[5, 10, 15, 20]"
              :page-size="page_size"
              layout="total, prev, pager, next, sizes, jumper"
              :total="dataListnum"
            >
            </el-pagination>
          </div>
          <!-- 分页 End -->
        </el-tab-pane>

        <!-- 管理课程动作 start -->
        <el-tab-pane :label="TabSecondTitle" name="second" style="height: 100%;">
          <WebTwoCourseAction
            ref="SubVuesecond"
            v-on:triggerFunc="BackToFirst"
          ></WebTwoCourseAction>
        </el-tab-pane>
        <!-- 管理课程动作 end -->
      </el-tabs>

      <!---------------------- 以下是弹框内容 ---------------------->
      <!-- 新增 -->
      <el-dialog
        title="添加课程"
        :visible.sync="dialogAdd"
        width="35%"
        class="newAdd"
        :close-on-click-modal="false"
        v-loading="uploadLoading"
      >
        <div class="addUser_body">
          <el-form ref="userMsg" :model="addData" label-width="150px">
            <el-form-item label="课程分类" :required="true">
              <el-select
                v-model="addData.courseType"
                multiple
                placeholder="课程分类"
              >
                <el-option
                  v-for="item in aptustwoGvListCourseType"
                  :key="item.gv"
                  :label="item.name"
                  :value="item.gv"
                >
                </el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="部位分类" :required="true">
              <el-select
                v-model="addData.bodyType"
                multiple
                placeholder="部位分类"
              >
                <el-option
                  v-for="item in aptustwoGvListBodyType"
                  :key="item.gv"
                  :label="item.name"
                  :value="item.gv"
                >
                </el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="课程名称" :required="true">
              <el-input
                v-model="addData.courseName"
                placeholder="请输入课程名称"
              ></el-input>
            </el-form-item>
            <el-form-item label="列表封面" :required="true">
              <el-upload
                class="cover-uploader"
                :action="''"
                :http-request="handleAddCourseIconUpload"
                :show-file-list="false"
                :before-upload="beforeImageUpload"
                :auto-upload="true"
              >
                <img
                  v-if="addData.courseIconUi || addData.courseIcon"
                  :src="
                    addData.courseIconUi || getImageUrl(addData.courseIcon)
                  "
                  class="cover-image"
                />
                <i v-else class="el-icon-plus cover-uploader-icon"></i>
              </el-upload>
              <div class="upload-tip">支持jpg、png格式，大小不超过2MB</div>
            </el-form-item>
            <el-form-item label="详情页封面" :required="true">
              <el-upload
                class="cover-uploader"
                :action="''"
                :http-request="handleAddCourseIconDetailsUpload"
                :show-file-list="false"
                :before-upload="beforeImageUpload"
                :auto-upload="true"
              >
                <img
                  v-if="
                    addData.courseIconDetailsUi || addData.courseIconDetails
                  "
                  :src="
                    addData.courseIconDetailsUi ||
                      getImageUrl(addData.courseIconDetails)
                  "
                  class="cover-image"
                />
                <i v-else class="el-icon-plus cover-uploader-icon"></i>
              </el-upload>
              <div class="upload-tip">支持jpg、png格式，大小不超过2MB</div>
            </el-form-item>
            <el-form-item label="Banner封面" :required="true">
              <el-upload
                class="cover-uploader"
                :action="''"
                :http-request="handleAddCourseIconBannerUpload"
                :show-file-list="false"
                :before-upload="beforeImageUpload"
                :auto-upload="true"
              >
                <img
                  v-if="
                    addData.courseIconBannerUi || addData.courseIconBanner
                  "
                  :src="
                    addData.courseIconBannerUi ||
                      getImageUrl(addData.courseIconBanner)
                  "
                  class="cover-image"
                />
                <i v-else class="el-icon-plus cover-uploader-icon"></i>
              </el-upload>
              <div class="upload-tip">支持jpg、png格式，大小不超过2MB</div>
            </el-form-item>
            <el-form-item label="课程难度" :required="true">
              <el-select
                v-model="addData.courseDifficulty"
                placeholder="课程难度"
              >
                <el-option
                  v-for="item in aptustwoGvListCourseDifficulty"
                  :key="item.gv"
                  :label="item.name"
                  :value="item.gv"
                >
                </el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="组之间的休息时长" :required="true">
              <el-input
                v-model="addData.courseRest"
                placeholder="请输入组之间的休息时长"
              >
                <template slot="append">
                  <span
                    style="width: 100px; display: inline-block;text-align: center;"
                    >秒</span
                  >
                </template>
              </el-input>
            </el-form-item>
            <el-form-item label="动作之间的休息时长" :required="true">
              <el-input
                v-model="addData.courseRestMax"
                placeholder="请输入动作之间的休息时长"
              >
                <template slot="append">
                  <span
                    style="width: 100px; display: inline-block;text-align: center;"
                    >秒</span
                  >
                </template>
              </el-input>
            </el-form-item>
            <el-form-item label="训练肌群" :required="true">
              <el-select
                v-model="addData.courseMuscleRoup"
                multiple
                placeholder="训练肌群"
              >
                <el-option
                  v-for="item in aptustwoGvListMuscleRoup"
                  :key="item.gv"
                  :label="item.name"
                  :value="item.gv"
                >
                </el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="所需配件" :required="true">
              <el-select
                v-model="addData.courseAccessories"
                multiple
                placeholder="所需配件"
              >
                <el-option
                  v-for="item in aptustwoGvListAccessories"
                  :key="item.gv"
                  :label="item.name"
                  :value="item.gv"
                >
                </el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="首页推荐" :required="true">
              <el-select v-model="addData.isHome" placeholder="首页推荐">
                <el-option label="否" value="0"></el-option>
                <el-option label="是" value="1"></el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="Banner推荐" :required="true">
              <el-select
                v-model="addData.isBanner"
                placeholder="Banner推荐"
              >
                <el-option label="否" value="0"></el-option>
                <el-option label="是" value="1"></el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="推荐标题" :required="true">
              <el-input
                v-model="addData.bannerTitle"
                placeholder="请输入推荐标题"
              ></el-input>
            </el-form-item>
            <el-form-item label="推荐描述" :required="true">
              <el-input
                type="textarea"
                v-model="addData.bannerDescription"
                placeholder="请输入推荐描述"
              ></el-input>
            </el-form-item>
            <el-divider content-position="left">运动处方标签</el-divider>
            <el-form-item label="适合性别">
              <el-select v-model="addData.dimSex" multiple placeholder="不选则不限">
                <el-option label="男" value="A"></el-option>
                <el-option label="女" value="B"></el-option>
                <el-option label="秘密" value="C"></el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="适合年龄段">
              <el-select v-model="addData.dimAge" multiple placeholder="不选则不限">
                <el-option label="少年(6-13)" value="A"></el-option>
                <el-option label="青年(14-17)" value="B"></el-option>
                <el-option label="成年(18-40)" value="C"></el-option>
                <el-option label="大师(41-64)" value="D"></el-option>
                <el-option label="银发(65+)" value="E"></el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="适合训练经验">
              <el-select v-model="addData.dimExperience" multiple placeholder="不选则不限">
                <el-option label="新手(<2月)" value="A"></el-option>
                <el-option label="入门(2-6月)" value="B"></el-option>
                <el-option label="熟练(6-12月)" value="C"></el-option>
                <el-option label="进阶(2级)" value="D"></el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="适合训练频率">
              <el-select v-model="addData.dimFrequency" multiple placeholder="不选则不限">
                <el-option label="低频(1-2次/周)" value="A"></el-option>
                <el-option label="常规(3-4次/周)" value="B"></el-option>
                <el-option label="高频(5+次/周)" value="C"></el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="适合训练强度">
              <el-select v-model="addData.dimIntensity" multiple placeholder="不选则不限">
                <el-option label="低强" value="A"></el-option>
                <el-option label="中强" value="B"></el-option>
                <el-option label="高强" value="C"></el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="适合技术熟练度">
              <el-select v-model="addData.dimSkill" multiple placeholder="不选则不限">
                <el-option label="无基础" value="A"></el-option>
                <el-option label="基础" value="B"></el-option>
                <el-option label="熟练" value="C"></el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="适合BMI分类">
              <el-select v-model="addData.dimBmi" multiple placeholder="不选则不限">
                <el-option label="正常(<24.9)" value="A"></el-option>
                <el-option label="超重(25-29.9)" value="B"></el-option>
                <el-option label="肥胖(30-34.9)" value="C"></el-option>
                <el-option label="严重肥胖(35-39.9)" value="D"></el-option>
                <el-option label="极度肥胖(≥40)" value="E"></el-option>
              </el-select>
            </el-form-item>
          </el-form>
        </div>
        <div slot="footer" class="dialog-footer">
          <el-button type="primary" :loading="submitLoading" @click="CourseDatabaseInsert()"
            >确定</el-button
          >
          <el-button @click="dialogAdd = false">取消</el-button>
        </div>
      </el-dialog>
      <!-- 新增 End -->

      <!-- 编辑课程 -->
      <el-dialog
        title="编辑课程"
        :visible.sync="dialogEdit"
        width="35%"
        class="newAdd"
        :close-on-click-modal="false"
        v-loading="uploadLoading"
      >
        <div class="addUser_body">
          <el-form ref="userMsg" :model="editData" label-width="150px">
            <el-form-item label="课程分类" :required="true">
              <el-select
                v-model="editData.courseType"
                multiple
                placeholder="课程分类"
              >
                <el-option
                  v-for="item in aptustwoGvListCourseType"
                  :key="item.gv"
                  :label="item.name"
                  :value="item.gv"
                >
                </el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="部位分类" :required="true">
              <el-select
                v-model="editData.bodyType"
                multiple
                placeholder="部位分类"
              >
                <el-option
                  v-for="item in aptustwoGvListBodyType"
                  :key="item.gv"
                  :label="item.name"
                  :value="item.gv"
                >
                </el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="课程名称" :required="true">
              <el-input
                v-model="editData.courseName"
                placeholder="请输入课程名称"
              ></el-input>
            </el-form-item>
            <el-form-item label="列表封面" :required="true">
              <el-upload
                class="cover-uploader"
                :action="''"
                :http-request="handleEditCourseIconUpload"
                :show-file-list="false"
                :before-upload="beforeImageUpload"
                :auto-upload="true"
              >
                <img
                  v-if="editData.courseIconUi || editData.courseIcon"
                  :src="
                    editData.courseIconUi ||
                      getImageUrl(editData.courseIcon)
                  "
                  class="cover-image"
                />
                <i v-else class="el-icon-plus cover-uploader-icon"></i>
              </el-upload>
              <div class="upload-tip">支持jpg、png格式，大小不超过2MB</div>
            </el-form-item>
            <el-form-item label="详情页封面" :required="true">
              <el-upload
                class="cover-uploader"
                :action="''"
                :http-request="handleEditCourseIconDetailsUpload"
                :show-file-list="false"
                :before-upload="beforeImageUpload"
                :auto-upload="true"
              >
                <img
                  v-if="
                    editData.courseIconDetailsUi ||
                      editData.courseIconDetails
                  "
                  :src="
                    editData.courseIconDetailsUi ||
                      getImageUrl(editData.courseIconDetails)
                  "
                  class="cover-image"
                />
                <i v-else class="el-icon-plus cover-uploader-icon"></i>
              </el-upload>
              <div class="upload-tip">支持jpg、png格式，大小不超过2MB</div>
            </el-form-item>
            <el-form-item label="Banner封面" :required="true">
              <el-upload
                class="cover-uploader"
                :action="''"
                :http-request="handleEditCourseIconBannerUpload"
                :show-file-list="false"
                :before-upload="beforeImageUpload"
                :auto-upload="true"
              >
                <img
                  v-if="
                    editData.courseIconBannerUi || editData.courseIconBanner
                  "
                  :src="
                    editData.courseIconBannerUi ||
                      getImageUrl(editData.courseIconBanner)
                  "
                  class="cover-image"
                />
                <i v-else class="el-icon-plus cover-uploader-icon"></i>
              </el-upload>
              <div class="upload-tip">支持jpg、png格式，大小不超过2MB</div>
            </el-form-item>
            <el-form-item label="课程难度" :required="true">
              <el-select
                v-model="editData.courseDifficulty"
                placeholder="课程难度"
              >
                <el-option
                  v-for="item in aptustwoGvListCourseDifficulty"
                  :key="item.gv"
                  :label="item.name"
                  :value="item.gv"
                >
                </el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="组之间的休息时长" :required="true">
              <el-input
                v-model="editData.courseRest"
                placeholder="请输入组之间的休息时长"
              >
                <template slot="append">
                  <span
                    style="width: 100px; display: inline-block;text-align: center;"
                    >秒</span
                  >
                </template>
              </el-input>
            </el-form-item>
            <el-form-item label="动作之间的休息时长" :required="true">
              <el-input
                v-model="editData.courseRestMax"
                placeholder="请输入动作之间的休息时长"
              >
                <template slot="append">
                  <span
                    style="width: 100px; display: inline-block;text-align: center;"
                    >秒</span
                  >
                </template>
              </el-input>
            </el-form-item>
            <el-form-item label="课程时长" :required="true">
              <el-input
                v-model="editData.courseTime"
                placeholder="请输入课程时长"
              >
                <template slot="append">
                  <span
                    style="width: 100px; display: inline-block;text-align: center;"
                    >秒</span
                  >
                </template>
              </el-input>
            </el-form-item>
            <el-form-item label="预计容量" :required="true">
              <el-input
                v-model="editData.courseKg"
                placeholder="请输入预计容量"
              >
                <template slot="append">
                  <span
                    style="width: 100px; display: inline-block;text-align: center;"
                    >Kg</span
                  >
                </template>
              </el-input>
            </el-form-item>
            <el-form-item label="预计消耗" :required="true">
              <el-input
                v-model="editData.courseKcal"
                placeholder="请输入预计消耗"
              >
                <template slot="append">
                  <span
                    style="width: 100px; display: inline-block;text-align: center;"
                    >Kcal</span
                  >
                </template>
              </el-input>
            </el-form-item>
            <el-form-item label="训练肌群" :required="true">
              <el-select
                v-model="editData.courseMuscleRoup"
                multiple
                placeholder="训练肌群"
              >
                <el-option
                  v-for="item in aptustwoGvListMuscleRoup"
                  :key="item.gv"
                  :label="item.name"
                  :value="item.gv"
                >
                </el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="所需配件" :required="true">
              <el-select
                v-model="editData.courseAccessories"
                multiple
                placeholder="所需配件"
              >
                <el-option
                  v-for="item in aptustwoGvListAccessories"
                  :key="item.gv"
                  :label="item.name"
                  :value="item.gv"
                >
                </el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="首页推荐" :required="true">
              <el-select v-model="editData.isHome" placeholder="首页推荐">
                <el-option label="否" value="0"></el-option>
                <el-option label="是" value="1"></el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="Banner推荐" :required="true">
              <el-select
                v-model="editData.isBanner"
                placeholder="Banner推荐"
              >
                <el-option label="否" value="0"></el-option>
                <el-option label="是" value="1"></el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="推荐标题" :required="true">
              <el-input
                v-model="editData.bannerTitle"
                placeholder="请输入推荐标题"
              ></el-input>
            </el-form-item>
            <el-form-item label="推荐描述" :required="true">
              <el-input
                type="textarea"
                v-model="editData.bannerDescription"
                placeholder="请输入推荐描述"
              ></el-input>
            </el-form-item>
            <el-divider content-position="left">运动处方标签</el-divider>
            <el-form-item label="适合性别">
              <el-select v-model="editData.dimSex" multiple placeholder="不选则不限">
                <el-option label="男" value="A"></el-option>
                <el-option label="女" value="B"></el-option>
                <el-option label="秘密" value="C"></el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="适合年龄段">
              <el-select v-model="editData.dimAge" multiple placeholder="不选则不限">
                <el-option label="少年(6-13)" value="A"></el-option>
                <el-option label="青年(14-17)" value="B"></el-option>
                <el-option label="成年(18-40)" value="C"></el-option>
                <el-option label="大师(41-64)" value="D"></el-option>
                <el-option label="银发(65+)" value="E"></el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="适合训练经验">
              <el-select v-model="editData.dimExperience" multiple placeholder="不选则不限">
                <el-option label="新手(<2月)" value="A"></el-option>
                <el-option label="入门(2-6月)" value="B"></el-option>
                <el-option label="熟练(6-12月)" value="C"></el-option>
                <el-option label="进阶(2级)" value="D"></el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="适合训练频率">
              <el-select v-model="editData.dimFrequency" multiple placeholder="不选则不限">
                <el-option label="低频(1-2次/周)" value="A"></el-option>
                <el-option label="常规(3-4次/周)" value="B"></el-option>
                <el-option label="高频(5+次/周)" value="C"></el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="适合训练强度">
              <el-select v-model="editData.dimIntensity" multiple placeholder="不选则不限">
                <el-option label="低强" value="A"></el-option>
                <el-option label="中强" value="B"></el-option>
                <el-option label="高强" value="C"></el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="适合技术熟练度">
              <el-select v-model="editData.dimSkill" multiple placeholder="不选则不限">
                <el-option label="无基础" value="A"></el-option>
                <el-option label="基础" value="B"></el-option>
                <el-option label="熟练" value="C"></el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="适合BMI分类">
              <el-select v-model="editData.dimBmi" multiple placeholder="不选则不限">
                <el-option label="正常(<24.9)" value="A"></el-option>
                <el-option label="超重(25-29.9)" value="B"></el-option>
                <el-option label="肥胖(30-34.9)" value="C"></el-option>
                <el-option label="严重肥胖(35-39.9)" value="D"></el-option>
                <el-option label="极度肥胖(≥40)" value="E"></el-option>
              </el-select>
            </el-form-item>
          </el-form>
        </div>
        <div slot="footer" class="dialog-footer">
          <el-button type="primary" :loading="submitLoading" @click="CourseDatabaseUpdate()"
            >确定</el-button
          >
          <el-button @click="dialogEdit = false">取消</el-button>
        </div>
      </el-dialog>
      <!-- 编辑课程 End -->

      <!-- 批量新增弹窗 -->
      <el-dialog
        title="批量新增课程"
        :visible.sync="dialogBatchAdd"
        fullscreen
        class="batch-dialog"
        :close-on-click-modal="false"
      >
        <div class="batch-add-container">
          <div class="batch-toolbar">
            <el-button
              type="primary"
              @click="addBatchRow"
              icon="el-icon-plus"
              >添加一行</el-button
            >
            <el-button
              type="warning"
              @click="clearBatchData"
              icon="el-icon-delete"
              >清空</el-button
            >
            <span class="batch-tip"
              >提示：表格支持直接编辑，必填字段不能为空</span
            >
          </div>

          <el-table
            :data="batchData"
            border
            stripe
            class="batch-table"
            height="calc(100vh - 220px)"
          >
            <el-table-column
              type="index"
              label="序号"
              width="90"
              align="center"
            ></el-table-column>

            <el-table-column label="课程分类" width="190">
              <template slot="header">
                <span class="required-field">课程分类</span>
              </template>
              <template slot-scope="scope">
                <el-select
                  v-model="scope.row.courseType"
                  multiple
                  placeholder="选择"
                  size="small"
                  style="width: 100%"
                >
                  <el-option
                    v-for="item in aptustwoGvListCourseType"
                    :key="item.gv"
                    :label="item.name"
                    :value="item.gv"
                  ></el-option>
                </el-select>
              </template>
            </el-table-column>

            <el-table-column label="部位分类" width="190">
              <template slot="header">
                <span class="required-field">部位分类</span>
              </template>
              <template slot-scope="scope">
                <el-select
                  v-model="scope.row.bodyType"
                  multiple
                  placeholder="选择"
                  size="small"
                  style="width: 100%"
                >
                  <el-option
                    v-for="item in aptustwoGvListBodyType"
                    :key="item.gv"
                    :label="item.name"
                    :value="item.gv"
                  ></el-option>
                </el-select>
              </template>
            </el-table-column>

            <el-table-column label="课程名称" width="190">
              <template slot="header">
                <span class="required-field">课程名称</span>
              </template>
              <template slot-scope="scope">
                <el-input
                  v-model="scope.row.courseName"
                  placeholder="必填"
                  size="small"
                ></el-input>
              </template>
            </el-table-column>

            <el-table-column label="列表封面" width="220">
              <template slot="header">
                <span class="required-field">列表封面</span>
              </template>
              <template slot-scope="scope">
                <el-upload
                  class="batch-uploader"
                  :action="''"
                  :http-request="
                    options =>
                      handleBatchIconUpload(
                        options,
                        scope.$index,
                        'courseIcon'
                      )
                  "
                  :show-file-list="false"
                  :before-upload="beforeImageUpload"
                  :auto-upload="true"
                >
                  <img
                    v-if="scope.row.courseIconUi || scope.row.courseIcon"
                    :src="
                      scope.row.courseIconUi ||
                        getImageUrl(scope.row.courseIcon)
                    "
                    class="batch-preview-image"
                  />
                  <el-button
                    v-else
                    size="mini"
                    type="primary"
                    icon="el-icon-upload"
                    >上传</el-button
                  >
                </el-upload>
              </template>
            </el-table-column>

            <el-table-column label="详情页封面" width="220">
              <template slot="header">
                <span class="required-field">详情页封面</span>
              </template>
              <template slot-scope="scope">
                <el-upload
                  class="batch-uploader"
                  :action="''"
                  :http-request="
                    options =>
                      handleBatchIconUpload(
                        options,
                        scope.$index,
                        'courseIconDetails'
                      )
                  "
                  :show-file-list="false"
                  :before-upload="beforeImageUpload"
                  :auto-upload="true"
                >
                  <img
                    v-if="
                      scope.row.courseIconDetailsUi ||
                        scope.row.courseIconDetails
                    "
                    :src="
                      scope.row.courseIconDetailsUi ||
                        getImageUrl(scope.row.courseIconDetails)
                    "
                    class="batch-preview-image"
                  />
                  <el-button
                    v-else
                    size="mini"
                    type="primary"
                    icon="el-icon-upload"
                    >上传</el-button
                  >
                </el-upload>
              </template>
            </el-table-column>

            <el-table-column label="Banner封面" width="220">
              <template slot="header">
                <span class="required-field">Banner封面</span>
              </template>
              <template slot-scope="scope">
                <el-upload
                  class="batch-uploader"
                  :action="''"
                  :http-request="
                    options =>
                      handleBatchIconUpload(
                        options,
                        scope.$index,
                        'courseIconBanner'
                      )
                  "
                  :show-file-list="false"
                  :before-upload="beforeImageUpload"
                  :auto-upload="true"
                >
                  <img
                    v-if="
                      scope.row.courseIconBannerUi ||
                        scope.row.courseIconBanner
                    "
                    :src="
                      scope.row.courseIconBannerUi ||
                        getImageUrl(scope.row.courseIconBanner)
                    "
                    class="batch-preview-image"
                  />
                  <el-button
                    v-else
                    size="mini"
                    type="primary"
                    icon="el-icon-upload"
                    >上传</el-button
                  >
                </el-upload>
              </template>
            </el-table-column>

            <el-table-column label="课程难度" width="160">
              <template slot="header">
                <span class="required-field">课程难度</span>
              </template>
              <template slot-scope="scope">
                <el-select
                  v-model="scope.row.courseDifficulty"
                  placeholder="选择"
                  size="small"
                  style="width: 100%"
                >
                  <el-option
                    v-for="item in aptustwoGvListCourseDifficulty"
                    :key="item.gv"
                    :label="item.name"
                    :value="item.gv"
                  ></el-option>
                </el-select>
              </template>
            </el-table-column>

            <el-table-column label="组之间的休息(秒)" width="170">
              <template slot="header">
                <span class="required-field">组之间的休息(秒)</span>
              </template>
              <template slot-scope="scope">
                <el-input
                  v-model="scope.row.courseRest"
                  placeholder=""
                  size="small"
                  type="number"
                ></el-input>
              </template>
            </el-table-column>

            <el-table-column label="动作之间的休息(秒)" width="190">
              <template slot="header">
                <span class="required-field">动作之间的休息(秒)</span>
              </template>
              <template slot-scope="scope">
                <el-input
                  v-model="scope.row.courseRestMax"
                  placeholder=""
                  size="small"
                  type="number"
                ></el-input>
              </template>
            </el-table-column>

            <el-table-column label="训练肌群" width="190">
              <template slot="header">
                <span class="required-field">训练肌群</span>
              </template>
              <template slot-scope="scope">
                <el-select
                  v-model="scope.row.courseMuscleRoup"
                  multiple
                  placeholder="选择"
                  size="small"
                  style="width: 100%"
                >
                  <el-option
                    v-for="item in aptustwoGvListMuscleRoup"
                    :key="item.gv"
                    :label="item.name"
                    :value="item.gv"
                  ></el-option>
                </el-select>
              </template>
            </el-table-column>

            <el-table-column label="所需配件" width="190">
              <template slot="header">
                <span class="required-field">所需配件</span>
              </template>
              <template slot-scope="scope">
                <el-select
                  v-model="scope.row.courseAccessories"
                  multiple
                  placeholder="选择"
                  size="small"
                  style="width: 100%"
                >
                  <el-option
                    v-for="item in aptustwoGvListAccessories"
                    :key="item.gv"
                    :label="item.name"
                    :value="item.gv"
                  ></el-option>
                </el-select>
              </template>
            </el-table-column>

            <el-table-column label="首页推荐" width="160">
              <template slot="header">
                <span class="required-field">首页推荐</span>
              </template>
              <template slot-scope="scope">
                <el-select
                  v-model="scope.row.isHome"
                  placeholder="选择"
                  size="small"
                  style="width: 100%"
                >
                  <el-option label="否" value="0"></el-option>
                  <el-option label="是" value="1"></el-option>
                </el-select>
              </template>
            </el-table-column>

            <el-table-column label="Banner推荐" width="160">
              <template slot="header">
                <span class="required-field">Banner推荐</span>
              </template>
              <template slot-scope="scope">
                <el-select
                  v-model="scope.row.isBanner"
                  placeholder="选择"
                  size="small"
                  style="width: 100%"
                >
                  <el-option label="否" value="0"></el-option>
                  <el-option label="是" value="1"></el-option>
                </el-select>
              </template>
            </el-table-column>

            <el-table-column label="推荐标题" width="190">
              <template slot="header">
                <span class="required-field">推荐标题</span>
              </template>
              <template slot-scope="scope">
                <el-input
                  v-model="scope.row.bannerTitle"
                  placeholder="必填"
                  size="small"
                ></el-input>
              </template>
            </el-table-column>

            <el-table-column label="推荐描述" width="220">
              <template slot="header">
                <span class="required-field">推荐描述</span>
              </template>
              <template slot-scope="scope">
                <el-input
                  v-model="scope.row.bannerDescription"
                  placeholder="推荐描述"
                  size="small"
                  type="textarea"
                  :rows="2"
                ></el-input>
              </template>
            </el-table-column>

            <el-table-column label="适合性别" width="190">
              <template slot="header">
                <span>适合性别</span>
              </template>
              <template slot-scope="scope">
                <el-select v-model="scope.row.dimSex" multiple placeholder="未选不限" size="small" style="width: 100%">
                  <el-option label="男" value="A"></el-option>
                  <el-option label="女" value="B"></el-option>
                  <el-option label="秘密" value="C"></el-option>
                </el-select>
              </template>
            </el-table-column>

            <el-table-column label="适合年龄段" width="220">
              <template slot="header">
                <span>适合年龄：</span>
              </template>
              <template slot-scope="scope">
                <el-select v-model="scope.row.dimAge" multiple placeholder="未选不限" size="small" style="width: 100%">
                  <el-option label="少年(6-13)" value="A"></el-option>
                  <el-option label="青年(14-17)" value="B"></el-option>
                  <el-option label="成年(18-40)" value="C"></el-option>
                  <el-option label="大师(41-64)" value="D"></el-option>
                  <el-option label="银发(65+)" value="E"></el-option>
                </el-select>
              </template>
            </el-table-column>

            <el-table-column label="适合训练经验" width="220">
              <template slot="header">
                <span>适合训练经验</span>
              </template>
              <template slot-scope="scope">
                <el-select v-model="scope.row.dimExperience" multiple placeholder="未选不限" size="small" style="width: 100%">
                  <el-option label="新手(<2月)" value="A"></el-option>
                  <el-option label="入门(2-6月)" value="B"></el-option>
                  <el-option label="熟练(6-12月)" value="C"></el-option>
                  <el-option label="进阶(2级)" value="D"></el-option>
                </el-select>
              </template>
            </el-table-column>

            <el-table-column label="适合训练频率" width="220">
              <template slot="header">
                <span>适合训练频率</span>
              </template>
              <template slot-scope="scope">
                <el-select v-model="scope.row.dimFrequency" multiple placeholder="未选不限" size="small" style="width: 100%">
                  <el-option label="低频(1-2次/周)" value="A"></el-option>
                  <el-option label="常规(3-4次/周)" value="B"></el-option>
                  <el-option label="高频(5+次/周)" value="C"></el-option>
                </el-select>
              </template>
            </el-table-column>

            <el-table-column label="适合训练强度" width="160">
              <template slot="header">
                <span>适合训练强度</span>
              </template>
              <template slot-scope="scope">
                <el-select v-model="scope.row.dimIntensity" multiple placeholder="未选不限" size="small" style="width: 100%">
                  <el-option label="低强" value="A"></el-option>
                  <el-option label="中强" value="B"></el-option>
                  <el-option label="高强" value="C"></el-option>
                </el-select>
              </template>
            </el-table-column>

            <el-table-column label="适合技术熟练度" width="170">
              <template slot="header">
                <span>适合技术熟练度</span>
              </template>
              <template slot-scope="scope">
                <el-select v-model="scope.row.dimSkill" multiple placeholder="未选不限" size="small" style="width: 100%">
                  <el-option label="无基础" value="A"></el-option>
                  <el-option label="基础" value="B"></el-option>
                  <el-option label="熟练" value="C"></el-option>
                </el-select>
              </template>
            </el-table-column>

            <el-table-column label="适合BMI分类" width="240">
              <template slot="header">
                <span>适合BMI分类</span>
              </template>
              <template slot-scope="scope">
                <el-select v-model="scope.row.dimBmi" multiple placeholder="未选不限" size="small" style="width: 100%">
                  <el-option label="正常(<24.9)" value="A"></el-option>
                  <el-option label="超重(25-29.9)" value="B"></el-option>
                  <el-option label="肥胖(30-34.9)" value="C"></el-option>
                  <el-option label="严重肥胖(35-39.9)" value="D"></el-option>
                  <el-option label="极度肥胖(≥40)" value="E"></el-option>
                </el-select>
              </template>
            </el-table-column>

            <el-table-column
              label="操作"
              width="170"
              fixed="right"
              align="center"
            >
              <template slot-scope="scope">
                <el-button
                  type="primary"
                  icon="el-icon-copy-document"
                  size="mini"
                  circle
                  @click="copyBatchRow(scope.$index)"
                ></el-button>
                <el-button
                  type="danger"
                  icon="el-icon-delete"
                  size="mini"
                  circle
                  @click="deleteBatchRow(scope.$index)"
                ></el-button>
              </template>
            </el-table-column>
          </el-table>
        </div>
        <div slot="footer" class="dialog-footer">
          <el-button
            type="success"
            @click="saveBatchData"
            :loading="batchLoading"
            icon="el-icon-check"
            >保存全部</el-button
          >
          <el-button @click="dialogBatchAdd = false">取消</el-button>
        </div>
      </el-dialog>
      <!-- 批量新增弹窗 End -->

      <!-- 翻译管理 -->
      <i18n-translation-dialog
        :visible.sync="dialogI18n"
        :entity-type="i18nEntityType"
        :entity-id="i18nEntityId"
        :fields="i18nFields">
      </i18n-translation-dialog>
      <!-- 翻译管理 End -->
    </div>
  </div>
</template>

<script>
import Vue from "vue";
import axios from "axios";
import VueAxios from "vue-axios";
import Qs from "qs";
import UploadExcel from "../components/UploadExcel.vue";
import WebTwoCourseAction from "@/componentsSubVue/WebTwoCourseAction.vue";
import I18nTranslationDialog from "@/components/I18nTranslationDialog.vue";
Vue.use(VueAxios, axios);

export default {
  components: {
    UploadExcel,
    WebTwoCourseAction,
    I18nTranslationDialog
  },
  data() {
    return {
      activeName: "first",
      formLabelWidth: "120px",
      aptustwoGvListCourseType: [],
      aptustwoGvListCourseDifficulty: [],
      aptustwoGvListCourseTimeType: [],
      aptustwoGvListBodyType: [],
      aptustwoGvListMuscleRoup: [],
      aptustwoGvListAccessories: [],
      queryData: {
        courseType: "0",
        priorityType: "1",
        courseDifficulty: "0",
        courseTimeType: "0",
        bodyType: "",
        courseAccessories: "",
        courseName: "",
        isHome: "-1",
        isBanner: "-1"
      },
      // 列表
      dataList: [],
      dataListnum: 0,
      courseStats: {
        total: 0,
        homeRecommend: 0,
        bannerRecommend: 0,
        avgTime: 0
      },
      filterCollapsed: false,
      tableHasScroll: false,
      tableHeight: 480,
      page_no: 1,
      page_size: 10,
      sortField: '',
      sortOrder: '',
      // 新增
      dialogAdd: false,
      addData: {
        courseType: [],
        bodyType: [],
        courseName: "",
        courseIcon: "",
        courseIconUi: "",
        courseIconDetails: "",
        courseIconDetailsUi: "",
        courseIconBanner: "",
        courseIconBannerUi: "",
        courseDifficulty: "",
        courseTime: "1",
        courseRest: "30",
        courseRestMax: "60",
        courseKg: "1",
        courseKcal: "1",
        courseMuscleRoup: [],
        courseAccessories: [],
        isHome: "",
        isBanner: "",
        bannerTitle: "",
        bannerDescription: "",
        dimSex: [],
        dimAge: [],
        dimExperience: [],
        dimFrequency: [],
        dimIntensity: [],
        dimSkill: [],
        dimBmi: []
      },
      uploadAction: Vue.prototype.global.Url_Base + "Upload/file",
      uploadLoading: false,
      submitLoading: false,
      // 编辑
      dialogEdit: false,
      editData: {
        id: "",
        courseType: [],
        bodyType: [],
        courseName: "",
        courseIcon: "",
        courseIconUi: "",
        courseIconDetails: "",
        courseIconDetailsUi: "",
        courseIconBanner: "",
        courseIconBannerUi: "",
        courseDifficulty: "",
        courseTime: "",
        courseRest: "",
        courseRestMax: "",
        courseKg: "",
        courseKcal: "",
        courseMuscleRoup: [],
        courseAccessories: [],
        isHome: "",
        isBanner: "",
        bannerTitle: "",
        bannerDescription: "",
        dimSex: [],
        dimAge: [],
        dimExperience: [],
        dimFrequency: [],
        dimIntensity: [],
        dimSkill: [],
        dimBmi: []
      },
      allowChangeTab: false,
      TabSecondTitle: "管理课程动作",
      // 批量新增
      dialogBatchAdd: false,
      batchData: [],
      batchLoading: false,
      // 翻译管理
      dialogI18n: false,
      i18nEntityId: null,
      i18nEntityType: 'COURSE',
      i18nFields: [
        { name: 'course_name', label: '课程名称', type: 'input' },
        { name: 'banner_title', label: '推荐标题', type: 'input' },
        { name: 'banner_description', label: '推荐描述', type: 'textarea' }
      ],
      translationMap: {}
    };
  },
  watch: {
    dialogI18n(val) {
      if (!val) {
        this.loadTranslations('COURSE', this.dataList, 'id')
      }
    }
  },
  mounted() {
    this.aptustwoGvListCourseType = JSON.parse(
      localStorage.getItem("aptustwoGvListCourseType")
    );
    this.aptustwoGvListCourseDifficulty = JSON.parse(
      localStorage.getItem("aptustwoGvListCourseDifficulty")
    );
    this.aptustwoGvListCourseTimeType = JSON.parse(
      localStorage.getItem("aptustwoGvListCourseTimeType")
    );
    this.aptustwoGvListBodyType = JSON.parse(
      localStorage.getItem("aptustwoGvListBodyType")
    );
    this.aptustwoGvListMuscleRoup = JSON.parse(
      localStorage.getItem("aptustwoGvListMuscleRoup")
    );
    this.aptustwoGvListAccessories = JSON.parse(
      localStorage.getItem("aptustwoGvListAccessories")
    );
    this.CourseDatabaseList();
    this.CourseDatabaseNum();
    this.CourseDatabaseStats();
    window.addEventListener('resize', this.onWindowResize)
    this.$nextTick(this.initTableResizeObserver)
  },
  beforeDestroy() {
    window.removeEventListener('resize', this.onWindowResize)
    this.destroyTableResizeObserver()
  },
  methods: {
    clickI18n(row) {
      this.i18nEntityId = row.id;
      this.dialogI18n = true;
    },
    BackToFirst(val) {
      this.activeName = "first";
      this.TabSecondTitle = "管理课程动作";
      this.CourseDatabaseList();
    },
    handleSizeChange(val) {
      this.page_size = val;
      this.CourseDatabaseList();
      this.CourseDatabaseNum();
      this.CourseDatabaseStats();
    },
    handleCurrentChange(val) {
      this.page_no = val;
      this.CourseDatabaseList();
      this.CourseDatabaseNum();
      this.CourseDatabaseStats();
    },
    handleSortChange({ prop, order }) {
      const fieldMap = {
        'courseTypeUi': 'courseType',
        'bodyTypeUi': 'bodyType',
        'courseDifficultyUi': 'courseDifficulty'
      };
      this.sortField = fieldMap[prop] || prop || '';
      this.sortOrder = order === 'ascending' ? 'asc' : (order === 'descending' ? 'desc' : '');
      this.page_no = 1;
      this.CourseDatabaseList();
      this.CourseDatabaseNum();
      this.CourseDatabaseStats();
    },
    tableHeaderStyle({ column }) {
      var style = { background: 'var(--aptus-surface-muted)', color: 'var(--aptus-text-secondary)', fontWeight: '600' }
      if (column.headerAlign) {
        style.textAlign = column.headerAlign
      } else if (column.align) {
        style.textAlign = column.align
      } else {
        style.textAlign = 'left'
      }
      return style
    },
    tableCellStyle({ column }) {
      if (column.type === 'index' || column.className === 'col-operations' || column.property === 'isHome' || column.property === 'isBanner') {
        return { textAlign: 'center' }
      }
      if (column.align) {
        return { textAlign: column.align }
      }
      return { textAlign: 'left' }
    },
    tableIndexMethod(index) {
      const seq = (this.page_no - 1) * this.page_size + index + 1
      if (this.sortOrder === 'asc') {
        return seq
      }
      return this.dataListnum - seq + 1
    },
    checkTableScroll() {
      var that = this
      this.$nextTick(function () {
        var el = that.$refs.tableContainer
        if (!el) return
        var bodyWrapper = el.querySelector('.el-table__body-wrapper')
        var target = bodyWrapper || el
        that.tableHasScroll = target.scrollWidth > target.clientWidth + 2
      })
    },
    calcTableHeight() {
      var that = this
      this.$nextTick(function () {
        var container = that.$refs.tableContainer
        if (!container) return
        var height = container.clientHeight
        if (height > 0) {
          that.tableHeight = Math.max(240, Math.floor(height))
        }
        that.checkTableScroll()
        if (that.$refs.courseTable) {
          that.$refs.courseTable.doLayout()
        }
      })
    },
    initTableResizeObserver() {
      var that = this
      this.calcTableHeight()
      if (typeof ResizeObserver === 'undefined') return
      this.tableResizeObserver = new ResizeObserver(function () {
        that.calcTableHeight()
      })
      if (this.$refs.tableContainer) {
        this.tableResizeObserver.observe(this.$refs.tableContainer)
      }
    },
    destroyTableResizeObserver() {
      if (this.tableResizeObserver) {
        this.tableResizeObserver.disconnect()
        this.tableResizeObserver = null
      }
    },
    onWindowResize() {
      this.calcTableHeight()
    },
    beforeTabLeave(activeName, oldActiveName) {
      if (!this.allowChangeTab && activeName !== "first") {
        this.$message.warning("禁止点击");
        return false;
      }
      this.allowChangeTab = false;
      return true;
    },
    clickQuery() {
      this.page_no = 1;
      this.CourseDatabaseList();
      this.CourseDatabaseNum();
      this.CourseDatabaseStats();
    },
    clickQueryReset() {
      this.queryData.courseType = "0";
      this.queryData.priorityType = "1";
      this.queryData.courseDifficulty = "0";
      this.queryData.courseTimeType = "0";
      this.queryData.bodyType = "";
      this.queryData.courseAccessories = "";
      this.queryData.courseName = "";
      this.queryData.isHome = "-1";
      this.queryData.isBanner = "-1";
      this.clickQuery();
    },
    clickdialogAdd() {
      this.dialogAdd = true;
      this.addData.courseType = [];
      this.addData.bodyType = [];
      this.addData.courseName = "";
      this.addData.courseIcon = "";
      this.addData.courseIconUi = "";
      this.addData.courseIconDetails = "";
      this.addData.courseIconDetailsUi = "";
      this.addData.courseIconBanner = "";
      this.addData.courseIconBannerUi = "";
      this.addData.courseDifficulty = "";
      this.addData.courseTime = "1";
      this.addData.courseRest = "30";
      this.addData.courseRestMax = "60";
      this.addData.courseKg = "1";
      this.addData.courseKcal = "1";
      this.addData.courseMuscleRoup = [];
      this.addData.courseAccessories = [];
      this.addData.isHome = "";
      this.addData.isBanner = "";
      this.addData.bannerTitle = "";
      this.addData.bannerDescription = "";
      this.addData.dimSex = [];
      this.addData.dimAge = [];
      this.addData.dimExperience = [];
      this.addData.dimFrequency = [];
      this.addData.dimIntensity = [];
      this.addData.dimSkill = [];
      this.addData.dimBmi = [];
    },
    clickdialogEdit(row) {
      this.dialogEdit = true;
      this.editData.id = row.id;
      this.editData.courseType = Vue.prototype.ConvertStringToArray(
        row.courseType
      );
      this.editData.bodyType = Vue.prototype.ConvertStringToArray(row.bodyType);
      this.editData.courseName = row.courseName;
      this.editData.courseIcon = row.courseIcon;
      this.editData.courseIconUi = row.courseIconUi;
      this.editData.courseIconDetails = row.courseIconDetails;
      this.editData.courseIconDetailsUi = row.courseIconDetailsUi;
      this.editData.courseIconBanner = row.courseIconBanner;
      this.editData.courseIconBannerUi = row.courseIconBannerUi;
      this.editData.courseDifficulty = row.courseDifficulty.toString();
      this.editData.courseTime = row.courseTime;
      this.editData.courseRest = row.courseRest;
      this.editData.courseRestMax = row.courseRestMax;
      this.editData.courseKg = row.courseKg;
      this.editData.courseKcal = row.courseKcal;
      this.editData.courseMuscleRoup = Vue.prototype.ConvertStringToArray(
        row.courseMuscleRoup
      );
      this.editData.courseAccessories = Vue.prototype.ConvertStringToArray(
        row.courseAccessories
      );
      this.editData.isHome = row.isHome.toString();
      this.editData.isBanner = row.isBanner.toString();
      this.editData.bannerTitle = row.bannerTitle;
      this.editData.bannerDescription = row.bannerDescription;
      this.editData.dimSex = [];
      this.editData.dimAge = [];
      this.editData.dimExperience = [];
      this.editData.dimFrequency = [];
      this.editData.dimIntensity = [];
      this.editData.dimSkill = [];
      this.editData.dimBmi = [];
      this.loadPrescriptionTag(1, row.id);
    },
    ClickDelete(row) {
      var that = this;
      this.$deleteConfirm('确定删除？').then(function () {
        that.CourseDatabaseDelete(row.id);
      });
    },
    gotoWebTwoCourseAction(row) {
      this.allowChangeTab = true;
      this.TabSecondTitle = "管理课程动作-" + row.courseName + "";
      this.activeName = "second";
      this.$refs.SubVuesecond.LoadData(row);
    },
    changeUploadExcel(response) {
      console.log(response);
      Vue.prototype.FunRemindOnlyError(response);
      if (response.code === 1) {
        Vue.prototype.FunRemindAllways(response.data);
        this.CourseDatabaseList();
        this.CourseDatabaseNum();
        this.CourseDatabaseStats();
      }
    },
    CourseDatabaseList: function() {
      var that = this;
      var data = Vue.prototype.FunGetBaseSignData();
      data.courseType = that.queryData.courseType;
      data.priorityType = that.queryData.priorityType;
      data.courseDifficulty = that.queryData.courseDifficulty;
      data.courseTimeType = that.queryData.courseTimeType;
      data.bodyType = that.queryData.bodyType;
      data.courseAccessories = that.queryData.courseAccessories;
      data.courseName = that.queryData.courseName;
      data.isHome = that.queryData.isHome;
      data.isBanner = that.queryData.isBanner;
      data.pageNo = that.page_no;
      data.pageSize = that.page_size;
      data.sortField = that.sortField;
      data.sortOrder = that.sortOrder;
      data.sign = Vue.prototype.FunGetSign(data);
      axios
        .post(Vue.prototype.global.Url_CourseDatabaseList, Qs.stringify(data))
        .then(function(response) {
          if (response.data.code === 1) {
            that.dataList = response.data.data;
            that.loadTranslations('COURSE', that.dataList, 'id');
          }
          that.calcTableHeight();
        })
        .catch(function(error) {
          console.log(error);
        });
    },
    loadTranslations: function(entityType, list, idField) {
      var that = this;
      if (!list || list.length === 0) {
        that.translationMap = {};
        return;
      }
      var ids = list.map(function(item) { return item[idField]; }).join(',');
      var data = Vue.prototype.FunGetBaseSignData();
      data.entityType = entityType;
      data.entityIds = ids;
      data.sign = Vue.prototype.FunGetSign(data);
      axios.get(Vue.prototype.global.Url_I18nBatchList, { params: data })
        .then(function(response) {
          if (response.data.code === 1) {
            that.translationMap = response.data.data || {};
          }
          that.$nextTick(function () {
            if (that.$refs.courseTable) {
              that.$refs.courseTable.doLayout()
            }
          })
        })
        .catch(function(error) {
          console.log(error);
        });
    },
    CourseDatabaseNum: function() {
      var that = this;
      var data = Vue.prototype.FunGetBaseSignData();
      data.courseType = that.queryData.courseType;
      data.priorityType = that.queryData.priorityType;
      data.courseDifficulty = that.queryData.courseDifficulty;
      data.courseTimeType = that.queryData.courseTimeType;
      data.bodyType = that.queryData.bodyType;
      data.courseAccessories = that.queryData.courseAccessories;
      data.courseName = that.queryData.courseName;
      data.isHome = that.queryData.isHome;
      data.isBanner = that.queryData.isBanner;
      data.sign = Vue.prototype.FunGetSign(data);
      axios
        .post(Vue.prototype.global.Url_CourseDatabaseNum, Qs.stringify(data))
        .then(function(response) {
          if (response.data.code === 1) {
            that.dataListnum = response.data.data;
          }
        })
        .catch(function(error) {
          console.log(error);
        });
    },
    CourseDatabaseStats: function() {
      var that = this;
      var data = Vue.prototype.FunGetBaseSignData();
      data.courseType = that.queryData.courseType;
      data.priorityType = that.queryData.priorityType;
      data.courseDifficulty = that.queryData.courseDifficulty;
      data.courseTimeType = that.queryData.courseTimeType;
      data.bodyType = that.queryData.bodyType;
      data.courseAccessories = that.queryData.courseAccessories;
      data.courseName = that.queryData.courseName;
      data.isHome = that.queryData.isHome;
      data.isBanner = that.queryData.isBanner;
      data.sign = Vue.prototype.FunGetSign(data);
      axios
        .post(Vue.prototype.global.Url_CourseDatabaseStats, Qs.stringify(data))
        .then(function(response) {
          if (response.data.code === 1) {
            var stats = response.data.data;
            that.courseStats = {
              total: stats.total || 0,
              homeRecommend: stats.homeRecommend || 0,
              bannerRecommend: stats.bannerRecommend || 0,
              avgTime: stats.avgTime || 0
            };
          }
        })
        .catch(function(error) {
          console.log(error);
        });
    },
    CourseDatabaseInsert: function() {
      var that = this;
      var data = Vue.prototype.FunGetBaseSignData();
      data.courseType = Vue.prototype.ConvertArrayToString(
        that.addData.courseType
      );
      data.bodyType = Vue.prototype.ConvertArrayToString(that.addData.bodyType);
      data.courseName = that.addData.courseName;
      data.courseIcon = that.addData.courseIcon;
      data.courseIconDetails = that.addData.courseIconDetails;
      data.courseIconBanner = that.addData.courseIconBanner;
      data.courseDifficulty = that.addData.courseDifficulty;
      data.courseTime = that.addData.courseTime;
      data.courseRest = that.addData.courseRest;
      data.courseRestMax = that.addData.courseRestMax;
      data.courseKg = that.addData.courseKg;
      data.courseKcal = that.addData.courseKcal;
      data.courseMuscleRoup = Vue.prototype.ConvertArrayToString(
        that.addData.courseMuscleRoup
      );
      data.courseAccessories = Vue.prototype.ConvertArrayToString(
        that.addData.courseAccessories
      );
      data.isHome = that.addData.isHome;
      data.isBanner = that.addData.isBanner;
      data.bannerTitle = that.addData.bannerTitle;
      data.bannerDescription = that.addData.bannerDescription;
      data.dimSex = that.addData.dimSex ? that.addData.dimSex.join(',') : '';
      data.dimAge = that.addData.dimAge ? that.addData.dimAge.join(',') : '';
      data.dimExperience = that.addData.dimExperience ? that.addData.dimExperience.join(',') : '';
      data.dimFrequency = that.addData.dimFrequency ? that.addData.dimFrequency.join(',') : '';
      data.dimIntensity = that.addData.dimIntensity ? that.addData.dimIntensity.join(',') : '';
      data.dimSkill = that.addData.dimSkill ? that.addData.dimSkill.join(',') : '';
      data.dimBmi = that.addData.dimBmi ? that.addData.dimBmi.join(',') : '';
      data.sign = Vue.prototype.FunGetSign(data);
      that.submitLoading = true;
      axios
        .post(Vue.prototype.global.Url_CourseDatabaseInsert, Qs.stringify(data))
        .then(function(response) {
          that.submitLoading = false;
          if (response.data.code === 1) {
            that.$message.success("新增成功");
            that.CourseDatabaseList();
            that.CourseDatabaseNum();
            that.CourseDatabaseStats();
            that.dialogAdd = false;
          } else {
            Vue.prototype.FunRemindOnlyError(response.data);
          }
        })
        .catch(function(error) {
          that.submitLoading = false;
          console.log(error);
          that.dialogAdd = false;
        });
    },
    CourseDatabaseUpdate: function() {
      var that = this;
      var data = Vue.prototype.FunGetBaseSignData();
      data.id = that.editData.id;
      data.courseType = Vue.prototype.ConvertArrayToString(
        that.editData.courseType
      );
      data.bodyType = Vue.prototype.ConvertArrayToString(
        that.editData.bodyType
      );
      data.courseName = that.editData.courseName;
      data.courseIcon = that.editData.courseIcon;
      data.courseIconDetails = that.editData.courseIconDetails;
      data.courseIconBanner = that.editData.courseIconBanner;
      data.courseDifficulty = that.editData.courseDifficulty;
      data.courseTime = that.editData.courseTime;
      data.courseRest = that.editData.courseRest;
      data.courseRestMax = that.editData.courseRestMax;
      data.courseKg = that.editData.courseKg;
      data.courseKcal = that.editData.courseKcal;
      data.courseMuscleRoup = Vue.prototype.ConvertArrayToString(
        that.editData.courseMuscleRoup
      );
      data.courseAccessories = Vue.prototype.ConvertArrayToString(
        that.editData.courseAccessories
      );
      data.isHome = that.editData.isHome;
      data.isBanner = that.editData.isBanner;
      data.bannerTitle = that.editData.bannerTitle;
      data.bannerDescription = that.editData.bannerDescription;
      data.sign = Vue.prototype.FunGetSign(data);
      that.submitLoading = true;
      axios
        .post(Vue.prototype.global.Url_CourseDatabaseUpdate, Qs.stringify(data))
        .then(function(response) {
          that.submitLoading = false;
          if (response.data.code === 1) {
            that.$message.success("编辑成功");
            that.dialogEdit = false;
            that.CourseDatabaseList();
            that.CourseDatabaseNum();
            that.CourseDatabaseStats();
            that.savePrescriptionTag(1, that.editData.id);
          } else {
            Vue.prototype.FunRemindOnlyError(response.data);
          }
        })
        .catch(function(error) {
          that.submitLoading = false;
          console.log(error);
          that.dialogEdit = false;
        });
    },
    CourseDatabaseDelete: function(id) {
      var that = this;
      var data = Vue.prototype.FunGetBaseSignData();
      data.id = id;
      data.sign = Vue.prototype.FunGetSign(data);
      that.submitLoading = true;
      axios
        .post(Vue.prototype.global.Url_CourseDatabaseDelete, Qs.stringify(data))
        .then(function(response) {
          that.submitLoading = false;
          if (response.data.code === 1) {
            that.$message.success("删除成功");
            that.CourseDatabaseList();
            that.CourseDatabaseNum();
            that.CourseDatabaseStats();
          } else {
            Vue.prototype.FunRemindOnlyError(response.data);
          }
        })
        .catch(function(error) {
          that.submitLoading = false;
          console.log(error);
        });
    },
    // 图片上传前校验
    beforeImageUpload(file) {
      const isImage =
        file.type === "image/jpeg" ||
        file.type === "image/png" ||
        file.type === "image/jpg";
      const isLt2M = file.size / 1024 / 1024 < 2;

      if (!isImage) {
        this.$message.error("上传图片只能是 JPG 或 PNG 格式!");
        return false;
      }
      if (!isLt2M) {
        this.$message.error("上传图片大小不能超过 2MB!");
        return false;
      }
      return true;
    },
    // 新增-列表封面上传
    handleAddCourseIconUpload(options) {
      this.handleFileUpload(options, "add", "courseIcon", "images/course/");
    },
    // 新增-详情页封面上传
    handleAddCourseIconDetailsUpload(options) {
      this.handleFileUpload(
        options,
        "add",
        "courseIconDetails",
        "images/course/"
      );
    },
    // 新增-Banner封面上传
    handleAddCourseIconBannerUpload(options) {
      this.handleFileUpload(
        options,
        "add",
        "courseIconBanner",
        "images/course/"
      );
    },
    // 编辑-列表封面上传
    handleEditCourseIconUpload(options) {
      this.handleFileUpload(options, "edit", "courseIcon", "images/course/");
    },
    // 编辑-详情页封面上传
    handleEditCourseIconDetailsUpload(options) {
      this.handleFileUpload(
        options,
        "edit",
        "courseIconDetails",
        "images/course/"
      );
    },
    // 编辑-Banner封面上传
    handleEditCourseIconBannerUpload(options) {
      this.handleFileUpload(
        options,
        "edit",
        "courseIconBanner",
        "images/course/"
      );
    },
    // 通用文件上传处理
    handleFileUpload(options, type, field, category) {
      var that = this;
      var formData = new FormData();
      var data = Vue.prototype.FunGetBaseSignData();

      // 显示 loading
      that.uploadLoading = true;

      // 先计算签名（只包含tempUuid、timestamp、authToken）
      data.sign = Vue.prototype.FunGetSign(data);

      // 签名后再添加type参数（type不参与签名计算）
      data.type = "ajax";

      // 添加文件
      formData.append("file", options.file);

      // 添加其他参数
      formData.append("tempUuid", data.tempUuid);
      formData.append("timestamp", data.timestamp);
      formData.append("type", data.type);
      formData.append("sign", data.sign);
      formData.append("category", category);

      // 使用axios手动上传
      axios
        .post(that.uploadAction, formData, {
          headers: {
            "Content-Type": "multipart/form-data"
          }
        })
        .then(function(response) {
          that.uploadLoading = false;
          if (response.data.code === 1) {
            // 使用返回的absoluteUrl，无需手动拼接URL
            const targetData = type === "add" ? that.addData : that.editData;
            const uiField = field + "Ui";
            // 使用$set确保响应式更新
            that.$set(targetData, field, response.data.data.relativeUrl);
            that.$set(targetData, uiField, response.data.data.absoluteUrl);
            that.$message.success("上传成功");
            options.onSuccess(response.data);
          } else {
            that.$message.error('上传失败' + response.data.message);
            options.onError(response.data);
          }
        })
        .catch(function(error) {
          that.uploadLoading = false;
          console.log(error);
          that.$message.error('上传失败');
          options.onError(error);
        });
    },
    // 图片URL处理
    getImageUrl(url) {
      if (!url) return "";
      // 如果已经是完整的URL(http://或https://开头),直接返回
      if (url.startsWith("http://") || url.startsWith("https://")) {
        return url;
      }
      // 兼容历史数据：如果是相对路径，拼接基础URL
      return Vue.prototype.global.Url_Base + url;
    },
    // 批量新增 - 打开弹窗
    clickBatchAdd() {
      this.dialogBatchAdd = true;
      // 默认添加一行
      if (this.batchData.length === 0) {
        this.addBatchRow();
      }
    },
    // 批量新增 - 添加一行
    addBatchRow() {
      this.batchData.push({
        courseType: [],
        bodyType: [],
        courseName: "",
        courseIcon: "",
        courseIconUi: "",
        courseIconDetails: "",
        courseIconDetailsUi: "",
        courseIconBanner: "",
        courseIconBannerUi: "",
        courseDifficulty: "",
        courseTime: "1",
        courseRest: "30",
        courseRestMax: "60",
        courseKg: "1",
        courseKcal: "1",
        courseMuscleRoup: [],
        courseAccessories: [],
        isHome: "0",
        isBanner: "0",
        bannerTitle: "",
        bannerDescription: "",
        dimSex: [],
        dimAge: [],
        dimExperience: [],
        dimFrequency: [],
        dimIntensity: [],
        dimSkill: [],
        dimBmi: []
      });
    },
    // 批量新增 - 删除一行
    deleteBatchRow(index) {
      this.$deleteConfirm('确定删除该行数据？')
        .then(() => {
          this.batchData.splice(index, 1);
          this.$message.success("删除成功");
        })
        .catch(() => {});
    },
    // 批量新增 - 复制一行
    copyBatchRow(index) {
      var newRow = JSON.parse(JSON.stringify(this.batchData[index]));
      this.batchData.splice(index + 1, 0, newRow);
      this.$message.success("复制成功");
    },
    // 批量新增 - 清空
    clearBatchData() {
      this.$deleteConfirm('确定清空所有数据？')
        .then(() => {
          this.batchData = [];
          this.$message.success("清空成功");
        })
        .catch(() => {});
    },
    // 批量新增 - 图片上传
    handleBatchIconUpload(options, index, field) {
      var that = this;
      var formData = new FormData();
      var data = Vue.prototype.FunGetBaseSignData();

      // 先计算签名（只包含tempUuid、timestamp、authToken）
      data.sign = Vue.prototype.FunGetSign(data);

      // 签名后再添加type参数（type不参与签名计算）
      data.type = "ajax";

      // 添加文件
      formData.append("file", options.file);

      // 添加其他参数
      formData.append("tempUuid", data.tempUuid);
      formData.append("timestamp", data.timestamp);
      formData.append("type", data.type);
      formData.append("sign", data.sign);
      formData.append("category", "images/course/");

      // 使用axios手动上传
      axios
        .post(that.uploadAction, formData, {
          headers: {
            "Content-Type": "multipart/form-data"
          }
        })
        .then(function(response) {
          if (response.data.code === 1) {
            const uiField = field + "Ui";
            // 使用$set确保响应式更新
            that.$set(
              that.batchData[index],
              field,
              response.data.data.relativeUrl
            );
            that.$set(
              that.batchData[index],
              uiField,
              response.data.data.absoluteUrl
            );
            that.$message.success("上传成功");
            options.onSuccess(response.data);
          } else {
            that.$message.error('上传失败' + response.data.message);
            options.onError(response.data);
          }
        })
        .catch(function(error) {
          console.log(error);
          that.$message.error('上传失败');
          options.onError(error);
        });
    },
    // 批量新增 - 保存数据
    saveBatchData() {
      var that = this;

      // 校验必填字段
      for (let i = 0; i < that.batchData.length; i++) {
        const row = that.batchData[i];
        if (!row.courseType || row.courseType.length === 0) {
          that.$message.error(`第${i + 1}行：课程分类不能为空`);
          return;
        }
        if (!row.bodyType || row.bodyType.length === 0) {
          that.$message.error(`第${i + 1}行：部位分类不能为空`);
          return;
        }
        if (!row.courseName) {
          that.$message.error(`第${i + 1}行：课程名称不能为空`);
          return;
        }
        if (!row.courseIcon) {
          that.$message.error(`第${i + 1}行：列表封面不能为空`);
          return;
        }
        if (!row.courseIconDetails) {
          that.$message.error(`第${i + 1}行：详情页封面不能为空`);
          return;
        }
        if (!row.courseIconBanner) {
          that.$message.error(`第${i + 1}行：Banner封面不能为空`);
          return;
        }
        if (!row.courseDifficulty) {
          that.$message.error(`第${i + 1}行：课程难度不能为空`);
          return;
        }
        if (!row.courseMuscleRoup || row.courseMuscleRoup.length === 0) {
          that.$message.error(`第${i + 1}行：训练肌群不能为空`);
          return;
        }
        if (!row.courseAccessories || row.courseAccessories.length === 0) {
          that.$message.error(`第${i + 1}行：所需配件不能为空`);
          return;
        }
        if (!row.isHome) {
          that.$message.error(`第${i + 1}行：首页推荐不能为空`);
          return;
        }
        if (!row.isBanner) {
          that.$message.error(`第${i + 1}行：Banner推荐不能为空`);
          return;
        }
        if (!row.bannerTitle) {
          that.$message.error(`第${i + 1}行：推荐标题不能为空`);
          return;
        }
        if (!row.bannerDescription) {
          that.$message.error(`第${i + 1}行：推荐描述不能为空`);
          return;
        }
      }

      // 构造批量新增数据
      const courseList = that.batchData.map(row => ({
        courseType: Vue.prototype.ConvertArrayToString(row.courseType),
        bodyType: Vue.prototype.ConvertArrayToString(row.bodyType),
        courseName: row.courseName,
        courseIcon: row.courseIcon,
        courseIconDetails: row.courseIconDetails,
        courseIconBanner: row.courseIconBanner,
        courseDifficulty: row.courseDifficulty,
        courseTime: row.courseTime,
        courseRest: row.courseRest,
        courseRestMax: row.courseRestMax,
        courseKg: row.courseKg,
        courseKcal: row.courseKcal,
        courseMuscleRoup: Vue.prototype.ConvertArrayToString(
          row.courseMuscleRoup
        ),
        courseAccessories: Vue.prototype.ConvertArrayToString(
          row.courseAccessories
        ),
        isHome: row.isHome,
        isBanner: row.isBanner,
        bannerTitle: row.bannerTitle,
        bannerDescription: row.bannerDescription,
        dimSex: row.dimSex ? row.dimSex.join(',') : '',
        dimAge: row.dimAge ? row.dimAge.join(',') : '',
        dimExperience: row.dimExperience ? row.dimExperience.join(',') : '',
        dimFrequency: row.dimFrequency ? row.dimFrequency.join(',') : '',
        dimIntensity: row.dimIntensity ? row.dimIntensity.join(',') : '',
        dimSkill: row.dimSkill ? row.dimSkill.join(',') : '',
        dimBmi: row.dimBmi ? row.dimBmi.join(',') : ''
      }));
      var data = {
        tempUuid: localStorage.getItem("tempUuid"),
        courseList: courseList
      };
      that.batchLoading = true;

      axios
        .post(
          Vue.prototype.global.Url_Base + "CourseDatabase/batchInsert",
          data,
          {
            headers: {
              "Content-Type": "application/json"
            }
          }
        )
        .then(function(response) {
          that.batchLoading = false;
          Vue.prototype.FunRemindOnlyError(response.data);
          if (response.data.code === 1) {
            that.$message.success("批量新增成功");
            that.batchData = [];
            that.dialogBatchAdd = false;
            that.CourseDatabaseList();
            that.CourseDatabaseNum();
            that.CourseDatabaseStats();
          }
        })
        .catch(function(error) {
          that.batchLoading = false;
          console.log(error);
          that.$message.error('批量新增失败');
        });
    },
    // 加载处方标签
    loadPrescriptionTag(targetType, targetId) {
      var that = this;
      var data = Vue.prototype.FunGetBaseSignData();
      data.targetType = targetType;
      data.targetId = targetId;
      data.sign = Vue.prototype.FunGetSign(data);
      axios.get(Vue.prototype.global.Url_Base + 'WebTwoPrescriptionTag/get', { params: data })
        .then(function(response) {
          if (response.data.code === 1 && response.data.data) {
            var tag = response.data.data;
            that.editData.dimSex = tag.dimSex ? tag.dimSex.split(',') : [];
            that.editData.dimAge = tag.dimAge ? tag.dimAge.split(',') : [];
            that.editData.dimExperience = tag.dimExperience ? tag.dimExperience.split(',') : [];
            that.editData.dimFrequency = tag.dimFrequency ? tag.dimFrequency.split(',') : [];
            that.editData.dimIntensity = tag.dimIntensity ? tag.dimIntensity.split(',') : [];
            that.editData.dimSkill = tag.dimSkill ? tag.dimSkill.split(',') : [];
            that.editData.dimBmi = tag.dimBmi ? tag.dimBmi.split(',') : [];
          }
        })
        .catch(function(error) {
          console.log(error);
        });
    },
    // 保存处方标签
    savePrescriptionTag(targetType, targetId, sourceData) {
      var that = this;
      sourceData = sourceData || that.editData;
      var data = Vue.prototype.FunGetBaseSignData();
      data.targetType = targetType;
      data.targetId = targetId;
      data.dimSex = sourceData.dimSex ? sourceData.dimSex.join(',') : '';
      data.dimAge = sourceData.dimAge ? sourceData.dimAge.join(',') : '';
      data.dimExperience = sourceData.dimExperience ? sourceData.dimExperience.join(',') : '';
      data.dimFrequency = sourceData.dimFrequency ? sourceData.dimFrequency.join(',') : '';
      data.dimIntensity = sourceData.dimIntensity ? sourceData.dimIntensity.join(',') : '';
      data.dimSkill = sourceData.dimSkill ? sourceData.dimSkill.join(',') : '';
      data.dimBmi = sourceData.dimBmi ? sourceData.dimBmi.join(',') : '';
      data.sign = Vue.prototype.FunGetSign(data);
      axios.post(Vue.prototype.global.Url_Base + 'WebTwoPrescriptionTag/save', Qs.stringify(data))
        .then(function(response) {
          if (response.data.code !== 1) {
            Vue.prototype.FunRemindOnlyError(response.data);
          }
        })
        .catch(function(error) {
          console.log(error);
        });
    }
  }
};
</script>

<style lang="less" scoped>
/* ============================================================
 *  CourseDatabaseManagement · 课程管理设计规范 v1.0
 *  主色: #2563EB (深海蓝)  强调色: #FF6F00 (活力橙)
 * ============================================================ */

.course-page {
  /* 页面级 CSS 变量，基于全局 design-system.css */
  --aptus-primary: #2563EB;
  --aptus-primary-light: #3B82F6;
  --aptus-primary-bg: #EFF6FF;
  --aptus-accent: #FF6F00;
  --aptus-accent-bg: #FFF5EB;
  --aptus-success: #2E7D32;
  --aptus-success-bg: #EDF7ED;
  --aptus-danger: #C62828;
  --aptus-danger-bg: #FDECEC;
  --aptus-warning: #F57F17;
  --aptus-surface: #FFFFFF;
  --aptus-surface-muted: #F5F6F8;
  --aptus-border: #E2E6EC;
  --aptus-border-light: #EFF1F5;
  --aptus-text: #1A1D21;
  --aptus-text-secondary: #5E6670;
  --aptus-text-muted: #9AA3B0;

  width: 100%;
  height: calc(100vh - 88px);
  max-height: calc(100vh - 88px);
  overflow: hidden;
  display: flex;
  flex-direction: column;
  box-sizing: border-box;
}

.main_r {
  height: 100%;
  padding: 16px 20px 14px;
  display: flex;
  flex-direction: column;
  min-height: 0;
  overflow: hidden;
  box-sizing: border-box;
}

.page-top {
  flex-shrink: 0;
  margin-bottom: 12px;
}

.page-top__header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 12px;
}

.page-top.is-collapsed .page-top__body {
  display: none;
}

.collapse-toggle {
  font-size: 13px;
  font-weight: 500;
  padding: 4px 10px;
  border-radius: 6px;
  transition: all 200ms ease;

  i {
    margin-right: 4px;
    font-size: 12px;
  }

  &:hover {
    background: var(--aptus-primary-bg);
  }
}

/* 页面标题 */
.title_line {
  margin-bottom: 12px;
  font-size: 18px;
  font-weight: 700;
  color: var(--aptus-text);
  display: flex;
  align-items: center;
  gap: 10px;

  &::before {
    content: '';
    width: 4px;
    height: 22px;
    background: linear-gradient(180deg, var(--aptus-primary) 0%, var(--aptus-primary-light) 100%);
    border-radius: 2px;
  }
}

/* 统计卡片组 */
.stats-bar {
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  gap: 12px;
  margin-bottom: 12px;
}

.stat-card {
  display: flex;
  flex-direction: column;
  gap: 4px;
  padding: 14px 16px;
  background: var(--aptus-surface);
  border: 1px solid var(--aptus-border);
  border-radius: 8px;
  box-shadow: 0 1px 3px rgba(15, 26, 46, 0.06);
  transition: all 200ms ease;
  position: relative;
  overflow: hidden;

  /* 左侧彩色装饰条 */
  &::before {
    content: '';
    position: absolute;
    left: 0;
    top: 0;
    bottom: 0;
    width: 3px;
    background: var(--aptus-primary);
    border-radius: 8px 0 0 8px;
  }

  &:hover {
    box-shadow: 0 4px 12px rgba(15, 26, 46, 0.1);
    transform: translateY(-1px);
  }

  .stat-value {
    display: flex;
    align-items: center;
    gap: 6px;
    font-size: 24px;
    font-weight: 700;
    color: var(--aptus-text);
    line-height: 1.2;
  }

  .stat-label {
    font-size: 12px;
    color: var(--aptus-text-muted);
    font-weight: 500;
    text-transform: uppercase;
    letter-spacing: 0.5px;
  }
}

/* 各统计卡片主题色 */
.stat-total::before { background: var(--aptus-primary); }
.stat-total .stat-value { color: var(--aptus-primary); }

.stat-home::before { background: var(--aptus-success); }
.stat-home .stat-value { color: var(--aptus-success); }

.stat-banner::before { background: var(--aptus-accent); }
.stat-banner .stat-value { color: var(--aptus-accent); }

.stat-avg::before { background: var(--aptus-primary); }
.stat-avg .stat-value { color: var(--aptus-primary); }

/* 筛选栏 */
.filter-strip {
  display: flex;
  align-items: flex-end;
  gap: 12px;
  padding: 8px 12px;
  background: var(--aptus-surface);
  border: 1px solid var(--aptus-border);
  border-radius: 8px;
  box-shadow: 0 1px 3px rgba(15, 26, 46, 0.04);
}

.filter-strip__fields {
  display: grid;
  grid-template-columns: repeat(6, minmax(0, 1fr));
  gap: 6px 10px;
  flex: 1;
  min-width: 0;
}

.filter-field--compact {
  gap: 2px;

  /deep/ .el-input,
  /deep/ .el-select,
  /deep/ .el-date-editor {
    width: 100%;
  }
}

.filter-field {
  display: flex;
  flex-direction: column;
  min-width: 0;
}

.filter-field__label {
  font-size: 12px;
  color: var(--aptus-text-secondary);
  font-weight: 500;
  line-height: 1;
  margin-bottom: 2px;
}

.filter-strip__actions {
  display: flex;
  align-items: center;
  flex-shrink: 0;
  gap: 8px;

  /deep/ .el-button {
    margin-left: 0;
  }
}

.filter-strip__sep {
  width: 1px;
  height: 24px;
  background: var(--aptus-border);
  margin: 0 2px;
}

/* 状态指示点 */
.status-dot {
  display: inline-block;
  width: 8px;
  height: 8px;
  border-radius: 50%;
  flex-shrink: 0;

  &.is-home {
    background: var(--aptus-success);
    box-shadow: 0 0 0 3px rgba(46, 125, 50, 0.2);
  }

  &.is-banner {
    background: var(--aptus-accent);
    box-shadow: 0 0 0 3px rgba(255, 111, 0, 0.2);
  }
}

/* 表格区域 */
.table-section {
  flex: 1;
  min-height: 0;
  display: flex;
  flex-direction: column;
  overflow: hidden;
  margin-top: 12px;
}

.table-scroll-hint {
  display: flex;
  align-items: center;
  gap: 4px;
  flex-shrink: 0;
  margin-bottom: 6px;
  font-size: 11px;
  color: var(--aptus-text-muted);
  font-weight: 500;

  i {
    font-size: 11px;
  }
}

.table-container {
  position: relative;
  flex: 1;
  min-height: 0;
  width: 100%;
  background: var(--aptus-surface);
  border-radius: 8px;
  border: 1px solid var(--aptus-border);
  overflow: hidden;
}

/* 课程表格 */
.course-table {
  /deep/ .col-mono {
    font-family: 'SF Mono', Monaco, 'Cascadia Code', Consolas, monospace;
    font-variant-numeric: tabular-nums;
    letter-spacing: -0.01em;
    color: var(--aptus-text-secondary);
  }

  /deep/ .col-datetime .cell {
    white-space: nowrap;
    font-family: 'SF Mono', Monaco, 'Cascadia Code', Consolas, monospace;
    font-variant-numeric: tabular-nums;
    letter-spacing: -0.01em;
    color: var(--aptus-text-secondary);
  }

  /deep/ .col-mono .cell {
    white-space: nowrap;
  }

  /deep/ .el-table__body td {
    padding: 12px 0;
    background: var(--aptus-surface);
    border-bottom: 1px solid var(--aptus-border-light);
  }

  /deep/ .el-table__body tr:hover > td {
    background: var(--aptus-primary-bg) !important;
  }

  /deep/ .el-table__header th {
    padding: 12px 0;
    background: var(--aptus-surface-muted) !important;
    border-bottom: 1px solid var(--aptus-border);
    color: var(--aptus-text-secondary);
    font-weight: 600;
    font-size: 12px;
    text-transform: uppercase;
    letter-spacing: 0.5px;
  }

  /deep/ .el-table__header th .cell {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    white-space: nowrap;
    word-break: keep-all;
    line-height: 20px;
    padding: 0 8px;
  }

  /deep/ .el-table__header th .caret-wrapper {
    flex-shrink: 0;
    margin-left: 4px;
    vertical-align: middle;
  }

  /deep/ .el-table__fixed-right-patch {
    background: var(--aptus-surface-muted);
  }

  /deep/ .el-table__fixed-header-wrapper th,
  /deep/ .el-table__fixed .el-table__fixed-header-wrapper th {
    background: var(--aptus-surface-muted) !important;
  }

  /deep/ .el-table__fixed-right td {
    background: var(--aptus-surface) !important;
  }

  /deep/ .el-table__fixed-body-wrapper td {
    background: var(--aptus-surface);
    border-bottom: 1px solid var(--aptus-border-light);
  }

  /deep/ .el-table__fixed-body-wrapper tr:hover > td {
    background: var(--aptus-primary-bg) !important;
  }

  /deep/ .col-operations .cell {
    padding: 0 8px;
  }

  /deep/ thead tr th {
    border-radius: 0 !important;
  }
}

/* 操作按钮组 */
.action-group {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 2px;
  white-space: nowrap;

  .action-btn {
    padding: 4px;
    margin: 0;
    min-width: auto;
    font-size: 15px;
    line-height: 1;
    color: var(--aptus-primary);
    border-radius: 5px;
    transition: all 200ms ease;

    &:hover {
      background-color: var(--aptus-primary-bg);
    }

    &.action-btn--danger {
      color: var(--aptus-danger);

      &:hover {
        background-color: var(--aptus-danger-bg);
      }
    }
  }

  .el-link {
    font-size: 15px;
    padding: 4px 5px;
    border-radius: 5px;
    transition: all 200ms ease;
    line-height: 1;

    &:hover {
      background-color: var(--aptus-primary-bg);
    }

    &.el-link--primary:hover {
      background-color: var(--aptus-primary-bg);
    }

    &.el-link--danger:hover {
      background-color: var(--aptus-danger-bg);
    }

    &.el-link--warning:hover {
      background-color: var(--aptus-accent-bg);
    }

    &.el-link--success:hover {
      background-color: var(--aptus-success-bg);
    }
  }
}

/* 分页 */
.pagination-wrapper {
  display: flex;
  justify-content: flex-end;
  flex-shrink: 0;
  margin-top: 10px;
  padding-top: 10px;
  border-top: 1px solid var(--aptus-border);
}

/* 响应式 */
@media (max-width: 1400px) {
  .filter-strip {
    flex-wrap: wrap;
  }

  .filter-strip__fields {
    grid-template-columns: repeat(3, minmax(0, 1fr));
    width: 100%;
  }

  .filter-strip__actions {
    width: 100%;
    justify-content: flex-end;
  }
}

@media (max-width: 1200px) {
  .stats-bar {
    grid-template-columns: repeat(2, 1fr);
  }
}

@media (max-width: 768px) {
  .course-page {
    height: calc(100vh - 72px);
  }

  .main_r {
    padding: 10px;
  }

  .stats-bar {
    grid-template-columns: 1fr 1fr;
  }

  .filter-strip__fields {
    grid-template-columns: 1fr 1fr;
  }
}

/* 通用表单 */
.el-form-item {
  margin-bottom: 16px;
}

.jingwei {
  margin-top: -8px;

  .zuobiao{
    margin-bottom: -10px;

    p {
      margin: 0;
    }

    & p:nth-child(2){
      margin-top: -10px;
    }
  }
}

.position{
  overflow: hidden;
  height: 332px;
  background: var(--aptus-surface-muted);
}

/* 弹窗样式 */
.newAdd /deep/ .el-dialog__footer {
  padding: 16px 24px;
  text-align: right;
  border-top: 1px solid var(--aptus-border-light);
}

.newAdd /deep/ .el-dialog__header {
  padding: 18px 24px;
  background: var(--aptus-surface-muted);
  border-bottom: 1px solid var(--aptus-border-light);
}

.newAdd /deep/ .el-dialog__headerbtn {
  top: 20px;
  right: 20px;
}

.newAdd /deep/ .el-dialog__title {
  font-size: 16px;
  font-weight: 600;
  color: var(--aptus-text);
}

.custom-tree-node {
  flex: 1;
  display: flex;
  align-items: center;
  justify-content: space-between;
  font-size: 14px;
  padding-right: 8px;
}

.addUser_body{
  padding: 0 46px 0 30px;
  max-height: 60vh;
  overflow-y: auto;
}

/* 按钮主题覆盖 */
/deep/ .el-button--primary {
  color: #FFF;
  background-color: var(--aptus-primary);
  border-color: var(--aptus-primary);
  font-weight: 500;
  border-radius: 6px;

  &:hover {
    background-color: var(--aptus-primary-light);
    border-color: var(--aptus-primary-light);
    box-shadow: 0 2px 8px rgba(21, 101, 192, 0.25);
  }
}

/deep/ .el-button--primary.is-plain {
  color: var(--aptus-primary);
  background: var(--aptus-primary-bg);
  border-color: #A8D0F5;

  &:hover {
    background: var(--aptus-primary);
    color: #FFF;
    border-color: var(--aptus-primary);
  }
}

// 上传组件样式
.cover-uploader {
  /deep/ .el-upload {
    border: 1px dashed #d9d9d9;
    border-radius: 6px;
    cursor: pointer;
    position: relative;
    overflow: hidden;
  }
  /deep/ .el-upload:hover {
    border-color: #409eff;
  }
}

.cover-uploader-icon {
  font-size: 28px;
  color: #8c939d;
  width: 150px;
  height: 150px;
  line-height: 150px;
  text-align: center;
}

.cover-image {
  width: 150px;
  height: 150px;
  display: block;
  object-fit: cover;
}

.upload-tip {
  font-size: 12px;
  color: #999;
  margin-top: 8px;
}

// 批量新增样式
.batch-dialog {
  /deep/ .el-dialog {
    display: flex;
    flex-direction: column;
  }

  /deep/ .el-dialog__header {
    padding: 15px 20px;
    background: #f6f6fa;
    flex-shrink: 0;
  }

  /deep/ .el-dialog__body {
    padding: 0;
    flex: 1;
    overflow: hidden;
  }

  /deep/ .el-dialog__footer {
    padding: 15px 20px;
    text-align: center;
    border-top: 1px solid #f2f2f2;
    flex-shrink: 0;
  }
}

.batch-add-container {
  padding: 15px;
  height: 100%;
  display: flex;
  flex-direction: column;
}

.batch-toolbar {
  margin-bottom: 15px;
  display: flex;
  align-items: center;
  gap: 10px;
  flex-shrink: 0;

  .batch-tip {
    color: #909399;
    font-size: 14px;
    margin-left: 20px;
  }
}

.batch-table {
  flex: 1;

  /deep/ .el-table__body-wrapper {
    overflow-x: auto;
  }

  /deep/ .el-input__inner {
    padding: 5px 10px;
  }

  /deep/ .el-textarea__inner {
    padding: 5px 10px;
    min-height: 50px !important;
  }

  /deep/ .el-select {
    width: 100%;
  }
}

// 批量上传组件样式
.batch-uploader {
  /deep/ .el-upload {
    display: block;
    text-align: center;
  }
}

.batch-preview-image {
  width: 60px;
  height: 60px;
  display: block;
  object-fit: cover;
  cursor: pointer;
  border-radius: 4px;
  margin: 0 auto;
}

// 必填字段标记
.required-field {
  &::before {
    content: "*";
    color: #f56c6c;
    margin-right: 4px;
  }
}
</style>

<style scoped>
/* 隐藏 Tab Header（管理课程动作为代码控制跳转，不可手动点击） */
::v-deep .el-tabs {
  display: flex;
  flex-direction: column;
}

::v-deep .el-tabs > .el-tabs__header {
  display: none;
}

::v-deep .el-tabs--border-card {
  background: transparent;
  border: none;
  box-shadow: none;
}

::v-deep .el-tabs__content {
  flex: 1;
  padding: 0;
  overflow: hidden;
}

::v-deep .el-tab-pane {
  height: 100%;
  display: flex;
  flex-direction: column;
}
</style>
